import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import { AboutUsPage } from '@pages/AboutUsPage';
import { ContactPage } from '@pages/ContactPage';
import { GuidesPage } from '@pages/GuidesPage';
import { HomePage } from '@pages/HomePage';
import { PrivacyPolicy } from '@pages/PrivacyPolicy';
import { ServicesPage } from '@pages/ServicesPage';
import { TermsConditions } from '@pages/TermsConditions';
import { ToolsPage } from '@pages/ToolsPage';

import { CAGRCalculator } from '@tools/CAGRCalculator';
import { GoalPlanner } from '@tools/GoalPlanner';
import { HomeLoanCalculator } from '@tools/HomeLoanCalculator';
import { LumpsumCalculator } from '@tools/LumpsumCalculator';
import { ProfitLossCalculator } from '@tools/ProfitLossCalculator';
import { RetirementPlanner } from '@tools/RetirementPlanner';
import { RiskProfiler } from '@tools/RiskProfiler';
import { SignaturePlacer } from '@tools/SignaturePlacer';
import { SIPCalculator } from '@tools/SIPCalculator';
import { SIPDelayCalculator } from '@tools/SIPDelayCalculator';
import { SWPCalculator } from '@tools/SWPCalculator';
import { TaxCalculator } from '@tools/TaxCalculator';

import { InvestingInMutualFunds } from '@guides/InvestingInMutualFunds';
import { RetirementPlanning } from '@guides/RetirementPlanning';
import { SIPInvestmentStrategy } from '@guides/SIPInvestmentStrategy';

// --- Main App Component ---

export default function App(): React.JSX.Element {
  return (
    <Router>
      <main className="bg-gray-50 min-h-screen w-full overflow-x-hidden">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/tools" element={<ToolsPage />} />
          <Route path="/tools/sip-calculator" element={<SIPCalculator />} />
          <Route path="/tools/swp-calculator" element={<SWPCalculator />} />
          <Route
            path="/tools/lumpsum-calculator"
            element={<LumpsumCalculator />}
          />
          <Route path="/tools/goal-planner" element={<GoalPlanner />} />
          <Route path="/tools/tax-calculator" element={<TaxCalculator />} />
          <Route
            path="/tools/home-loan-calculator"
            element={<HomeLoanCalculator />}
          />
          <Route
            path="/tools/retirement-planner"
            element={<RetirementPlanner />}
          />
          <Route
            path="/tools/profit-loss-calculator"
            element={<ProfitLossCalculator />}
          />
          <Route path="/tools/risk-profiler" element={<RiskProfiler />} />
          <Route path="/tools/cagr-calculator" element={<CAGRCalculator />} />
          <Route
            path="/tools/sip-delay-calculator"
            element={<SIPDelayCalculator />}
          />
          <Route path="/tools/signature" element={<SignaturePlacer />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/guides" element={<GuidesPage />} />
          <Route
            path="/guides/investing-in-mutual-funds"
            element={<InvestingInMutualFunds />}
          />
          <Route
            path="/guides/retirement-planning"
            element={<RetirementPlanning />}
          />
          <Route
            path="/guides/sip-investment-strategy"
            element={<SIPInvestmentStrategy />}
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
        </Routes>
      </main>
    </Router>
  );
}
